<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="cn" id="pro"><a href="#/text/nav#rpro">Prologue</a></h2>
<p class="noindent"><span class="right_1" epub:type="pagebreak" id="page_1" title="1">That’s how it always is. In the ice, first you hear the voice of the Beast, then you die.</span></p>
<p class="indent">There were seracs and chasms identical to those in which I now found myself, full of mountaineers and rock climbers who had lost their strength, their reason, and finally their lives because of that voice.</p>
<p class="indent">Part of my mind, the animal part that knew what terror was because it had lived in terror for millions of years, understood what the Beast was hissing.</p>
<p class="indent">Two words: “Get out.”</p>
<p class="indent">I wasn’t prepared for the voice of the Beast.</p>
<p class="indent">I needed something familiar, something human, to tear me from the stark solitude of the ice. I raised my eyes beyond the edges of the crevasse, searching for the red outline of Dolomite Mountain Rescue’s EC135. But the sky was empty, wide open, the blue of it blinding.</p>
<p class="indent">That’s what made me fall apart.</p>
<p class="indent">I started rocking back and forth, my breathing rapid, my blood drained of any energy. Like Jonah in the belly of the whale, I was alone in the presence of God.</p>
<p class="indent">And God was roaring: “Get out.”</p>
<p class="indent">At two nineteen p.m. on that damned September 15, a voice emerged from the ice, and it wasn’t the voice of the Beast. It was Manny’s voice. His red uniform stood out in all that white, and he was repeating my name, over and over, as the pulley slowly lowered him toward me.</p>
<p class="indent">Fifteen feet.</p>
<p class="indent">Five.</p>
<p class="indent">His hands and eyes searched for wounds that would explain my <span class="right_1" epub:type="pagebreak" id="page_2" title="2">behavior. His questions: a hundred whats and a thousand whys I couldn’t answer. The voice of the Beast was too loud. It was devouring me.</span></p>
<p class="indent">“Don’t you hear it?” I murmured. “The Beast, the . . .”</p>
<p class="indent">The Beast, I’d have liked to tell him, that ancient thing of ice, couldn’t stand the idea of a warm heart buried in its depths. My warm heart. And his.</p>
<p class="indent">And now it was two twenty-two.</p>
<p class="indent">The expression of surprise on Manny’s face turning to pure terror. The pulley cable lifting him like a puppet. Manny being jerked upward. The rumble of the helicopter’s turbines becoming a strangled cry.</p>
<p class="indent">At last.</p>
<p class="indent">God’s scream. The avalanche wiping out the sky.</p>
<p class="indent"><i>Get out!</i></p>
<p class="indent">That was when I saw. When I was alone again, beyond time and space, I saw.</p>
<p class="indent">The darkness.</p>
<p class="indent">Total darkness. But I didn’t die. Oh, no. The Beast mocked me. It let me live. The Beast that was now whispering, “You will stay with me forever, forever . . .”</p>
<p class="indent">It wasn’t lying.</p>
<p class="indent">Part of me is still there.</p>
<p class="indent">But, as my daughter Clara would have said with a smile, that wasn’t the <i>z</i> at the end of the rainbow. It wasn’t the end of my story. On the contrary.</p>
<p class="indent">It was only the beginning.</p>
<p class="indent">One word, nine letters: “Beginning.” Five letters: “Beast.”</p>
<p class="indent">Six letters: “Horror.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062680181_Prologue.vue?62a4e17c